export enum DepotLocation {
  DROP_OFF = 'dropOffDepot',
  PICK_UP = 'pickUpDepot',
}
